import { createStore, applyMiddleware, Store } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { rootReducer } from './../Reducers/index';

const createStoreWithMiddleware = applyMiddleware(thunkMiddleware)(createStore);

export function configureStore(initialState?: any) {
    return createStoreWithMiddleware(rootReducer, initialState);
}



// WEBPACK FOOTER //
// ./ClientApp/app/Store/configurestore.tsx